import type { OrganizationScope } from "@/types/organization-scope"

export function normalizePositiveShopId(value?: number | null) {
  if (value == null) return undefined
  const normalized = Number(value)
  if (!Number.isFinite(normalized) || normalized <= 0) return undefined
  return Math.trunc(normalized)
}

export function resolveActiveShopId(options: {
  activeScope?: OrganizationScope | null
  userShopId?: number | null
}) {
  const scope = options.activeScope
  if (scope?.enabled && (scope.type === "shop" || scope.type === "chain-store")) {
    return normalizePositiveShopId(scope.meta?.shopId) ?? normalizePositiveShopId(options.userShopId)
  }
  if (scope?.type === "chain-headquarter" || scope?.type === "chain-region") {
    return undefined
  }
  return normalizePositiveShopId(options.userShopId)
}
